import script from "./IPChangeHistoryDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./IPChangeHistoryDialog.vue?vue&type=script&setup=true&lang=js"

import "./IPChangeHistoryDialog.vue?vue&type=style&index=0&id=9a3689ee&scoped=true&lang=css"
import "./IPChangeHistoryDialog.vue?vue&type=style&index=1&id=9a3689ee&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a3689ee"]])

export default __exports__